import Footer from "./Footer";

export default Footer;
export { Footer };
export type { FooterProps } from "./Footer";
